import { TokenProvider, TokenRefreshToken } from '@symphony-solo/shared/token-interceptor/src';
import { Observable } from 'rxjs';
import { AuthenticationFacade } from '../+state';
import { Injectable } from '@angular/core';
import { map, first } from 'rxjs/operators';

@Injectable()
export class AuthenticationTokenProvider extends TokenProvider {
  constructor(private authenticationFacade: AuthenticationFacade) {
    super();
  }
  public getToken(): Observable<TokenRefreshToken> {
    return this.authenticationFacade.getToken().pipe(
      map((token) => {
        if (!token) {
          return null;
        }
        return new TokenRefreshToken(token.token, token.refreshToken);
      }),
      first()
    );
  }
}
